import {ConnectBasicEntityExt} from '../../framework/message/ConnectBasicEntityExt';
import {StepParameter} from './StepParameter';
import {TranslatedEmb} from '../../../../allkey/locale/message/TranslatedEmb';

export class ProcessStepExt extends ConnectBasicEntityExt {
description: TranslatedEmb;
fid: number | null;
flowCode: string;
label: TranslatedEmb;
mediumExitStatus: string;
order: number | null;
params: StepParameter;
predefinedKind: string;
processCode: string;
visionCode: string;
}

